<template>
  <div class="box">
    <!-- 试卷搜索框 -->
    <div class="searchBox flex align spaceBetween">
      <input @keydown.enter="publicGetExam('搜索')" v-model="searchInput" class="searchInput" type="text"
        placeholder="输入试卷名称" />
      <img @click="publicGetExam('搜索')" class="searchIcon pointer" src="@/assets/resourceManagement/searchIcon.png"
        alt="" />
    </div>
    <!-- 功能列表 -->
    <div class="flex spaceBetween">
      <div></div>
      <div class="flex align">
        <img @click="testPaperUpload" class="batchUpload pointer" src="@/assets/resourceManagement/batchUpload.png"
          alt="" />
        <img @click="showPopupPaperGroupingMode = true" class="addTestpaper pointer"
          src="@/assets/resourceManagement/addTestpaper1.png" alt="" />
      </div>
    </div>
    <!-- 试卷列表表格 -->
    <div class="partingLine"></div>
    <el-table :data="testPaperList" :row-style="{ height: '0.3rem' }" fit height="calc(100% - 0.5rem)">
      <el-table-column show-overflow-tooltip align="center" prop="exam.name" label="试卷名称"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.type" label="类型"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.start_StopTime" label="考试起止时间">
      </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.examUsage" label="考试用途"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.testDuration" label="考试时长"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.num_item" label="题目数量"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center" prop="exam.score" label="分值"> </el-table-column>
      <el-table-column show-overflow-tooltip align="center">
        <template slot-scope="scope">
          <div class="flex align">
            <div @click="revise(scope.$index)" class="reviseTxt pointer">修改</div>
            <img @click="deleteResources(scope.$index)" class="btnDelete pointer"
              src="@/assets/resourceManagement/btnDelete.png" />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 选择组卷方式弹窗 -->
    <div v-if="showPopupPaperGroupingMode" class="popup-paperGroupingMode flex align justify">
      <div class="paperGroupingMode-box flex column align">
        <img @click="showPopupPaperGroupingMode = false" class="btnClose pointer" src="@/assets/btnClose.png" alt="" />
        <div class="popup-title">请选择组卷方式</div>
        <div class="btnSelectATopicBox flex spaceBetween">
          <img @click="createTestPaper('manual')" ref="btnSelectATopic1" class="btnSelectATopic pointer"
            src="@/assets/greyManualTopicSelection.png" alt="" />
          <img @click="createTestPaper('auto')" ref="btnSelectATopic2" class="btnSelectATopic pointer"
            src="@/assets/greyAutomaticTopicSelection.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 删除资源弹窗 -->
    <div v-if="showDeleteResources" class="pop-deleteResources">
      <div class="deleteResources">
        <img @click="showDeleteResources = false" class="btnClose pointer" src="../../../assets/btnClose.png" />
        <div class="deleteResourcesTxt">删除后将无法继续使用此资源，确定要将删除吗？</div>
        <div @click="btnAffirm" class="btnAffirm pointer">确认</div>
      </div>
    </div>
    <!-- 批量上传弹窗 -->
    <div v-if="showTestPaperUpload" class="pop-deleteResources">
      <div v-loading="loading" element-loading-text="拼命上传中..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.7)" class="resourcesBatchUpload-content">
        <img @click="showTestPaperUpload = false" class="btnClose pointer" src="@/assets/btnClose.png" />
        <div class="batchUpload-title">试卷上传</div>
        <div class="publicBottom flex spaceBetween" style="margin-top: 23px">
          <div></div>
          <img @click="templateDownload" class="templateDownload pointer" src="@/assets/classManagement/cm6.png" />
        </div>
        <!-- 试卷名称 -->
        <div class="publicBottom flex align">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">试卷名称:</div>
          </div>
          <div class="publicInput-box flex align spaceBetween">
            <input v-model="testPaperInformation.name" class="publicInput" type="text" placeholder="请输入试卷名称" />
          </div>
        </div>
        <!-- 试卷用途 -->
        <div class="publicBottom flex align">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">试卷用途:</div>
          </div>
          <div @click="selectUsage(item.value)" v-for="(item, index) in testPaperInformation.usage" :key="index"
            class="radio-content flex align pointer">
            <div class="radioBox" :style="testPaperInformation.selectUsage == item.value ? 'background: #349AFE;' : ''">
            </div>
            <div class="radioTxt" :style="testPaperInformation.selectUsage == item.value ? 'color: #349AFE;' : ''">{{
        item.name }}</div>
          </div>
        </div>
        <!-- 查看答案时机 -->
        <div class="publicBottom flex align spaceBetween">
          <div class="flex align">
            <div class="flex">
              <div class="requiredIcon">*</div>
              <div class="informationTxt">查看答案时机:</div>
            </div>
            <div @click="selectSeeTheAnswerWhen(item.value)"
              v-for="(item, index) in testPaperInformation.seeTheAnswerWhen" :key="index"
              class="radio-content flex align pointer">
              <div class="radioBox"
                :style="testPaperInformation.selectSeeTheAnswerWhen == item.value ? 'background: #349AFE;' : ''"></div>
              <div class="radioTxt"
                :style="testPaperInformation.selectSeeTheAnswerWhen == item.value ? 'color: #349AFE;' : ''">{{ item.name
                }}
              </div>
            </div>
            <el-date-picker v-if="testPaperInformation.selectSeeTheAnswerWhen == 'time'"
              v-model="testPaperInformation.seeTheAnswerTime" type="date" placeholder="选择日期"> </el-date-picker>
          </div>
        </div>
        <!-- 考试起止时间 -->
        <div class="publicBottom flex align">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">考试起止时间:</div>
          </div>
          <div class="radio-content">
            <el-date-picker v-model="testPaperInformation.startStopTime" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
          </div>
        </div>
        <!-- 考试时长 -->
        <div class="publicBottom flex align">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">考试时长:</div>
          </div>
          <div class="radio-content flex align">
            <el-slider class="sliderBar" :marks="testPaperInformation.marks" :show-input="true" input-size="medium"
              :show-input-controls="false" v-model="testPaperInformation.testDuration" :step="30" show-stops :max="120">
            </el-slider>
            <div class="sliderInputTxt">分钟</div>
          </div>
        </div>
        <!-- 表格上传 -->
        <div class="publicBottom flex align">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">表格上传:</div>
          </div>
          <div class="radio-content flex align">
            <div class="upload-box">
              <img class="upload-img pointer" @click="btnResourcesFormImport" src="@/assets/classManagement/cm7.png" />
              <div v-show="showResourcesFormImport" class="submitSuccessfully flex align justify">
                <img class="submitSuccessfullyImg" src="@/assets/submitSuccessfully.png" />
              </div>
            </div>
          </div>
        </div>
        <!-- 确定按钮 -->
        <div class="flex justify">
          <div @click="btnPopAffirm" class="btnAffirmUpload pointer flex align justify">确定</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getExamList, delExam, resourceAssociationDel, resourceList } from "@/api";
import { Toast } from "vant";
import axios from "axios";
import store from "@/store";
export default {
  data() {
    return {
      searchInput: "", // 输入框搜索字段
      showTestPaperUpload: false, // 上传试卷弹窗
      testPaperList: [], // 试卷列表
      showPopupPaperGroupingMode: false, // 是否展示组卷方式弹窗
      createTestPaperType: "", // 创建试卷方式
      showDeleteResources: false, // 删除确认
      currentExam: null, // 当前试卷
      loading: false,
      showResourcesFormImport: false, // 控制资源上传的表格上传成功提示的显示
      formFile: "", // 上传表格的Base64
      // 试卷信息
      testPaperInformation: {
        name: "", // 试卷名称
        // 用途
        usage: [
          {
            name: "平时表现",
            value: "usually",
          },
          {
            name: "期中考试",
            value: "mid",
          },
          {
            name: "期末考试",
            value: "final",
          },
          {
            name: "其他考试",
            value: "other",
          },
        ],
        // 查看答案时机
        seeTheAnswerWhen: [
          {
            name: "交卷后可查看答案",
            value: "after",
          },
          {
            name: "不可查看答案",
            value: "no",
          },
          {
            name: "自定义时间",
            value: "time",
          },
        ],
        seeTheAnswerTime: "", // 查看答案时间
        startStopTime: "", // 起止时间
        testDuration: 0, // 考试时长
        marks: {
          0: "不限时",
          30: "30",
          60: "60",
          90: "90",
          120: "120",
        },
        selectUsage: "", // 选择的用途
        selectSeeTheAnswerWhen: "", // 选择的查看答案时机
      },
    };
  },
  created() {
    this.$store.commit("GET_questionBankData", []); // 清除数据
    this.publicGetExam(); // 获取试卷列表
  },
  methods: {
    // 公共获取试卷
    publicGetExam(type) {
      // 调用获取试卷列表接口
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        types: "exam",
        page: 1,
        num: 1000,
        lesson_item_id: 0,
      };
      resourceList(params).then((res) => {
        if (res.data.code == 0) {
          this.testPaperList = res.data.datas.forEach((item) => {
            let element = item.exam;
            if (element.types == "manual") {
              element.type = "手动组卷";
            } else if (element.types == "auto") {
              element.type = "自动组卷";
            }
            let startTime = element.time_begin.split("T")[0];
            let endTime = element.time_end.split("T")[0];
            element.start_StopTime = startTime + "—" + endTime; // 获取考试起止时间
            // console.log(element.start_StopTime);
            if (element.usage == "usually") {
              element.examUsage = "平时考试";
            } else if (element.usage == "mid") {
              element.examUsage = "期中考试";
            } else if (element.usage == "final") {
              element.examUsage = "期末考试";
            } else if (element.usage == "other") {
              element.examUsage = "其他考试";
            }
            if (element.time_total == 0) {
              element.testDuration = "不限时";
            } else {
              element.testDuration = element.time_total + "分钟";
            }
          });
          this.testPaperList = res.data.datas;
        }
      });
      // let params = {
      //   where: [
      //     { k: "category", v: "exam", op: "=", lk: "and" },
      //     { k: "user_id", v: this.$store.state.loginRecord.data.datas.id, op: "=", lk: "and" },
      //     { k: "lesson_id", v: this.$store.state.courseDetails.id, op: "=", lk: "and" },
      //   ],
      // };
      // if (type == "搜索") {
      //   params.where.push({ k: "name", v: "%" + this.searchInput + "%", op: "like", lk: "and" });
      // }
      // getExamList(params).then((res) => {
      //
      // });
    },
    // 试卷上传
    testPaperUpload() {
      this.showTestPaperUpload = true;
    },
    // 试卷上传确定
    btnPopAffirm() {
      if (this.testPaperInformation.name == "") {
        Toast("请输入试卷名称！");
      } else if (this.testPaperInformation.selectUsage == "") {
        Toast("请选择试卷用途！");
      } else if (this.testPaperInformation.selectSeeTheAnswerWhen == "") {
        Toast("请选择查看答案时机！");
      } else if (this.testPaperInformation.selectSeeTheAnswerWhen == "time" && this.testPaperInformation.seeTheAnswerTime == "") {
        Toast("请选择查看答案时间！");
      } else if (this.testPaperInformation.startStopTime == "") {
        Toast("请选择考试起止时间！");
      } else if (!this.formFile) {
        Toast("请上传表格！");
      } else {
        const beginDate = new Date(this.testPaperInformation.startStopTime[0]);
        const beginYear = beginDate.getFullYear();
        const beginMonth = String(beginDate.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
        const beginDay = String(beginDate.getDate()).padStart(2, "0");
        const beginFormattedDate = `${beginYear}-${beginMonth}-${beginDay} 00:00:00`; // 获取考试开始时间
        const endDate = new Date(this.testPaperInformation.startStopTime[1]);
        const endYear = endDate.getFullYear();
        const endMonth = String(endDate.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
        const endDay = String(endDate.getDate()).padStart(2, "0");
        const endFormattedDate = `${endYear}-${endMonth}-${endDay} 23:59:59`; // 获取考试开始时间
        // 调用导入试卷接口
        let formData = new FormData();
        formData.append("file", this.formFile); // 加入文件流参数
        formData.append("exam_name", this.testPaperInformation.name); // 加入试卷名称参数
        formData.append("usage", this.testPaperInformation.selectUsage); // 加入所属课次参数
        formData.append("category", "exam");
        formData.append("answer_limit", this.testPaperInformation.selectSeeTheAnswerWhen);
        formData.append("time_begin", beginFormattedDate);
        formData.append("time_end", endFormattedDate);
        formData.append("lesson_id", this.$store.state.courseDetails.id);
        formData.append("time_total", this.testPaperInformation.testDuration);
        if (this.testPaperInformation.selectSeeTheAnswerWhen == "time") {
          const date = new Date(this.testPaperInformation.seeTheAnswerTime);
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从 0 开始，需要 +1
          const day = String(date.getDate()).padStart(2, "0");
          const formattedDate = `${year}-${month}-${day} 00:00:00`;
          formData.append("answer_time", formattedDate);
        }
        axios
          .post(store.state.interfacePath + "api/import/exam_item", formData, {
            headers: {
              "user-token": this.$store.state.loginRecord.data.ext,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((response) => {
            let res = response.data;
            if (res.code == 0) {
              this.loading = false;
              this.showTestPaperUpload = false;
              this.publicGetExam(); // 获取试卷列表
            } else {
              this.loading = false;
              Toast("上传失败！");
            }
          })
          .catch((response) => { });
      }
    },
    // 资源表格导入
    btnResourcesFormImport() {
      let input = document.createElement("input"); // 创建一个input标签
      document.body.appendChild(input);
      input.style.display = "none";
      input.type = "file"; // 类型改成file 上传文件
      input.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"; // 接受类型
      input.click(); // 触发点击事件 调起文件夹
      input.onchange = (event) => {
        if (!event.target.files || !event.target.files[0]) {
          reject("未选择文件");
        } else {
          this.formFile = event.target.files[0]; // 文件路径
          this.showResourcesFormImport = true;
        }
      };
    },
    // 选择用途
    selectUsage(usage) {
      this.testPaperInformation.selectUsage = usage;
    },
    // 选择查看答案时机
    selectSeeTheAnswerWhen(type) {
      this.testPaperInformation.selectSeeTheAnswerWhen = type;
    },
    // 模版下载
    templateDownload() {
      var a = document.createElement("a");
      a.href = window.location.protocol + "//school.striveing.com/web/template/课程习题导入模板.xlsx";
      a.download = "课程习题导入模板.xlsx";
      document.body.appendChild(a);
      a.click();
    },
    // 创建试卷方式
    createTestPaper(type) {
      this.createTestPaperType = type; // 获取创建试卷方式
      if (type == "manual") {
        this.$refs.btnSelectATopic1.src = require("../../../assets/blueManualTopicSelection.png");
        this.$refs.btnSelectATopic2.src = require("../../../assets/greyAutomaticTopicSelection.png");
        this.$router.push({
          name: "manualTestComposition",
          params: { type: "add" },
        });
      } else if (type == "auto") {
        this.$refs.btnSelectATopic1.src = require("../../../assets/greyManualTopicSelection.png");
        this.$refs.btnSelectATopic2.src = require("../../../assets/blueAutomaticTopicSelection.png");
        this.$router.push({
          name: "automaticTestComposition",
          params: { type: "add" },
        });
      }
    },
    // 修改试卷
    revise(idx) {
      this.$router.push({
        name: "manualTestComposition",
        params: { record: this.testPaperList[idx].exam.id },
      });
    },
    // 删除试卷
    deleteResources(idx) {
      console.log(this.testPaperList[idx]);
      this.showDeleteResources = true;
      this.currentExam = this.testPaperList[idx];
    },
    // 删除资源弹窗确认按钮调取删除资源接口并关闭弹窗
    btnAffirm() {
      let data = { id: this.currentExam.exam.id };
      delExam(data).then((res) => {
        if (res.data.code == 0) {
          let data = { link_resource_id: this.currentExam.id };
          resourceAssociationDel(data).then((res) => {
            if (res.data.code == 0) {
              this.showDeleteResources = false;
              Toast("已删除！");
            }
          });
        }
      });
    },
  },
};
</script>

<style src="./index.css" scoped></style>
